import React from "react";

export const wrapSvgIcon = (svgFn) => {
  return function SvgIcon({
    width = 20,
    height = 20,
    className = "",
    style = {},
    title = "",
    ...props
  }) {
    const { content, viewBox } = svgFn(width, height);

    return (
      <svg
        width={width}
        height={height}
        viewBox={viewBox}
        className={className}
        style={style}
        aria-label={title}
        role="img"
        dangerouslySetInnerHTML={{ __html: content }}
        {...props}
      />
    );
  };
};
